import React from 'react';

import type { TypographyProps } from './types';
import { StyledHeading } from './StyledComponents';

export const MainHeading = ({
  children,
  testID,
  ...rest
}: TypographyProps): React.ReactElement => (
  <StyledHeading data-testid={testID} {...rest}>
    {children}
  </StyledHeading>
);
